export default __webpack_public_path__ + "static/db-e427802a59d778837818c69fb573aa20.png";